const USER_ADDED = 'User added successfully!'
const USER_UPDATED = 'User details updated successfully.'
const USER_DEACTIVATED = 'User deactivated successfully'
const REQUEST_SENT = 'Email sent successfully for account setup!'
const ACTIVE = 'User is  Active now'
const DEACTIVE = 'User is Inactive now'


export {USER_ADDED, USER_UPDATED,USER_DEACTIVATED , REQUEST_SENT};
